interface SectionHeaderProps {
  tag: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeader({ tag, title, desc, align = "left" }: SectionHeaderProps) {
  return (
    <div className={`mb-8 flex ${align === "center" ? "flex-col items-center text-center" : "flex-col items-start"}`}>
      <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
        <i className="ri-snowy-line"></i>
        {tag}
      </span>
      <h2 className="font-heading text-2xl font-normal tracking-wide text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc && <p className="mt-3 max-w-2xl text-sm text-foreground-600">{desc}</p>}
    </div>
  );
}